import { memo } from 'react';
import { Check, Close, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import {
  CancellationDueDeath,
  ChangeControlDataForm,
} from 'cancellations/view-models/cancellation-due-death';
import ChangeControlDataFormComponent from './change-control-data-form';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';

interface ChangeControlDataAccordionProps {
  expanded: boolean;
  toggle: () => void;
}

const ChangeControlDataAccordionComponent = ({
  expanded,
  toggle,
}: ChangeControlDataAccordionProps): React.ReactElement => {
  const formContext = useFormikContext<CancellationDueDeath>();
  const { changeControlDataForm } = formContext.values;
  const errors: FormikErrors<ChangeControlDataForm> | undefined = formContext.errors
    .changeControlDataForm as FormikErrors<ChangeControlDataForm>;
  const touched: FormikTouched<ChangeControlDataForm> | undefined = formContext.touched
    .changeControlDataForm as unknown as FormikTouched<ChangeControlDataForm>;

  const handleFormFieldChange = useEventCallback(
    (
      key: keyof ChangeControlDataForm,
      value: ChangeControlDataForm[keyof ChangeControlDataForm]
    ) => {
      const newForm = {
        ...formContext.values.changeControlDataForm,
        [key]: value,
      };
      formContext.setFieldValue('changeControlDataForm', newForm);
    }
  );

  return (
    <Accordion expanded={expanded} onChange={toggle}>
      <AccordionSummary
        aria-controls="panel-change-control-data-content"
        id="panel-change-control-data-content"
        expandIcon={<ExpandMore />}
      >
        {!!errors ? <Close color="error" /> : <Check color="success" />}
        <Typography>Dati di controllo modifica</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ChangeControlDataFormComponent
          errors={errors}
          changeControlDataForm={changeControlDataForm}
          touched={touched}
          handleFormFieldChange={handleFormFieldChange}
        />
      </AccordionDetails>
    </Accordion>
  );
};

ChangeControlDataAccordionComponent.displayName = 'Change control data accordion component';

const ChangeControlDataAccordion = memo(ChangeControlDataAccordionComponent);

export default ChangeControlDataAccordion;
